import { Company, Organization } from '../Company'
import { Address, IdentifiableObject } from '../types'
import { User } from '../Users'

export enum FormStatus {
    PENDING = 'PENDING',
    COMPLETED = 'COMPLETED',
    CANCELLED = 'CANCELLED',
    PAUSE = 'PAUSE',
}

export interface FormUser {
    name: string
    email: string
}

export interface PropertyFormTransition extends IdentifiableObject {
    form: number
    from_status: FormStatus
    to_status: FormStatus
    user: User
    created_date: string
    modified_date: string
}

export interface AddPropertyForm extends IdentifiableObject {
    property_name: string
    address: Address
    unit_count: number
    organization: Organization
    status: FormStatus
    channel: number
    transitions: PropertyFormTransition[]
    regional_manager: FormUser
    property_manager: FormUser | null
    other_users: FormUser[] | null
    created_date: string
    modified_date: string
    created_by: User
    start_date: string | null
    message_count: number
    notes: string | null
    billing_email: string | null
    entrata_id?: number | null
    self_service?: boolean
    company?: number | null
}

export interface AvailableEntrataProperty {
    entrata_id: number
    name: string
    address: string
    city: string
    state: string
    zip_code: string
    already_onboarded: boolean
}

export interface RemovePropertyForm extends IdentifiableObject {
    companies: Company[]
    organization: Organization
    reason: string
    created_by: User
    created_date: string
    modified_date: string
    status: FormStatus
    transitions: PropertyFormTransition[]
    channel: number
    message_count: number
    termination_date: string | null
}
